import type { DeleteRevisionResponse } from '@vy/api-definition';
import type { WeftApi } from '@vy/client';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

type DeleteRevisionRequest = Parameters<WeftApi['deleteRevision']>[0];

export function useDeleteRevision(
  options?: UseMutationOptions<DeleteRevisionResponse, unknown, DeleteRevisionRequest>,
) {
  return useMutation({
    mutationFn: async ({ contractId, revisionId }) => {
      const api = getPrivateApi();

      return api.deleteRevision({ contractId, revisionId });
    },
    ...options,
  });
}
